import { FREE_PACKAGE, PACKAGE_ALL_IN_ONE, PACKAGE_GROW, PACKAGE_PLUS_VIDEO, PACKAGE_RESET } from '../types';
const initialState = {
  package: null,
  number: -1,
  version: 0,
  status: 1,
  interval: null
};
const packages = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FREE_PACKAGE:
      return {
        package: FREE_PACKAGE,
        number: 0,
        version: Date.now(),
        status: 3,
        interval: 'month'
      };
    case PACKAGE_GROW:
      return {
        package: PACKAGE_GROW,
        number: 1,
        version: Date.now(),
        status: 3,
        interval: action.interval
      };
    case PACKAGE_PLUS_VIDEO:
      return {
        package: PACKAGE_PLUS_VIDEO,
        number: 2,
        version: Date.now(),
        status: 3,
        interval: action.interval
      };
    case PACKAGE_ALL_IN_ONE:
      return {
        package: PACKAGE_ALL_IN_ONE,
        number: 3,
        version: Date.now(),
        status: 3,
        interval: action.interval
      };
    case PACKAGE_RESET:
      return initialState;
    default:
      return state;
  }
};
export { packages };